import {BaseService} from "@/core/services/BaseService";

class ClaimFormService extends BaseService<any> {
  endpoint = "/claim-form"

  async createClaim(id, claimId) {
    return this.http().put<any>(`${this.endpoint}/${id}/claim/${claimId}`).then(res => {
      return res.data
    })
  }

  async decline(id, model) {
    return this.http().put<any>(`${this.endpoint}/${id}/decline`, model).then(res => {
      return res.data
    })
  }

  async exportPdf(id) {
    return this.http().get(this.endpoint + "/" + id + "/export/pdf", {responseType: "blob"}).then(res => {
      return res
    })
  }
}

export default new ClaimFormService();